// @flow

/* eslint-disable new-cap */

import { get } from 'lodash';

import {
  CLEAR_BOOKING_PRICE_AND_PAYMENT,
  FETCH_BOOKING_PRICE_AND_PAYMENT,
  FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED,
  FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED,
} from 'Store/member-space/booking/booking.constants';

import createReducer from 'Store/utils/createReducer';

const initialState = {
  data: null,
  isLoading: false,
  isLoaded: false,
  isOnError: false,
  errorResponse: null,
};

export default createReducer(initialState, {
  [FETCH_BOOKING_PRICE_AND_PAYMENT](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_BOOKING_PRICE_AND_PAYMENT_RESOLVED](state, action) {
    return {
      ...state,
      data: {
        ...state.data,
        priceDetails: get(action, 'payload.userBooking.priceDetails'),
        paymentDetails: get(action, 'payload.userBooking.paymentDetails'),
      },
      isLoaded: true,
      isLoading: false,
    };
  },
  [FETCH_BOOKING_PRICE_AND_PAYMENT_REJECTED](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      isOnError: true,
      errorResponse: { errors: action.payload.errors },
    };
  },
  [CLEAR_BOOKING_PRICE_AND_PAYMENT]() {
    return initialState;
  },
});
